import { React, useCallback } from "react";
import Css from "./Home.module.css";
import Particles from "react-particles";
import { loadSlim } from "tsparticles-slim";
import logo from "../Picture/logo.svg";
import Picture from "../Picture/home.png";
import { Typewriter } from "react-simple-typewriter";
import { Link } from "react-router-dom";
const pdf = "MohamedAdel-FrontEnd.pdf"; //here for source Pdf to Download not URL
const Home = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);
  const particlesLoaded = useCallback(async (container) => {}, []);

  const downloadPdf = (url) => {
    const fileName = url.split("/").pop();
    const aTag = document.createElement("a");
    aTag.href = url;
    aTag.setAttribute("download", fileName);
    document.body.appendChild(aTag);
    aTag.click();
    aTag.remove();
  };
  return (
    <div>
      <div className={Css.parent}>
        <Particles
          id="tsparticles"
          init={particlesInit}
          loaded={particlesLoaded}
          options={{
            background: {
              color: {
                value: "#1f242d",
              },
            },
            fpsLimit: 120,
            interactivity: {
              events: {
                onClick: {
                  enable: true,
                  mode: "push",
                },
                onHover: {
                  enable: true,
                  mode: "repulse",
                },
                resize: true,
              },
              modes: {
                push: {
                  quantity: 5,
                },
                repulse: {
                  distance: 150,
                  duration: 0.4,
                },
              },
            },
            particles: {
              color: {
                value: "#0ef",
              },
              links: {
                color: "#0ef",
                distance: 150,
                enable: true,
                opacity: 0.1,
                width: 1,
              },
              move: {
                direction: "none",
                enable: true,
                outModes: {
                  default: "bounce",
                },
                random: false,
                speed: 2,
                straight: false,
              },
              number: {
                density: {
                  enable: true,
                  area: 700,
                },
                value: 40,
              },
              opacity: {
                value: 0.3,
              },
              shape: {
                type: "circle",
              },
              size: {
                value: { min: 1, max: 3 },
              },
            },
            detectRetina: true,
          }}
        />
        <div className={Css.boxContainer}>
          <div className={Css.container}>
            <div className={Css.card}>
              <h2>Hello There,</h2>
              <h1>
                My Name's <span>Mohamed-Adel</span>
              </h1>
              <h1>And I'm a <span>
                  <Typewriter
                    words={["Front End Developer", "FrameWork React Js","FrameWork Next Js"]}
                    loop={1000}
                    cursor
                    cursorStyle="!"
                    typeSpeed={30}
                    deleteSpeed={20}
                    delaySpeed={1000}
                  />
                </span>
              </h1>
              <p>
                Welcome to my portfolio, i did this website to see all my
                projects, i wish this portfolio like you
              </p>
{/*               <Link onClick={()=>{downloadPdf(pdf)}}>Download CV</Link> */}
            </div>
            <div className={Css.card}>
              <div className={Css.img}>
                <img className={Css.shadow} src={logo} alt="" />
              </div>
              <img className={Css.twoimage} src={Picture} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
